import React from 'react';
import classNames from 'classnames';
import './styles.less';

/********************************************
 *  This adds a filtered background image or video to
 *  the containing div. Meant to be used in
 *  headers.
 *  
 *  See the styles.less for the filter vals:
 *  
 *  .overlay-filter {
 *     background-color: rgba(0, 0, 0, 0.5);
 *   }
 * 
 *  If type is image, add the image src in theme's css:
 * 
 *  Example:
 *  .filtered-image {
 *     background-image: url(...);
 *  }
 ***************************************/
 
const FilteredMedia = ( { children, style = {}, className, type } ) => {         
    return (
        <div 
            style={ style }
            className={ classNames( type === 'image' && 'filtered-image', 'filtered', className ) } 
        >
            { type === 'image' ?
                <div className="overlay-filter">
                    { children }
                </div>
            :
                <>
                    <div className="overlay-filter"></div>
                    { children }
                </>
            }
        </div>
    );
};

export default FilteredMedia;
 